import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { NotificacionDetalle } from '../../models/notificacion-detalle.model';
import { environment as ENV } from '../../../environments/environment';
import { URL_MAP } from '../../shared/urlMap';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class NotificacionDetalleService {
  private baseUrl = `${ENV.HOST}${URL_MAP.API.NOTIFICACION_DETALLE}`;

  constructor(private http: HttpClient) {}

  guardar(detalle: NotificacionDetalle): Observable<any> {
    return this.http.post(`${this.baseUrl}/guardar`, detalle);
  }

  mostrarActivos(): Observable<any[]> {
    return this.http.get<any[]>(`${this.baseUrl}/todas`);
  }

  obtenerDetallesPorAsesor(asesorId: number) {
    return this.http.get<any[]>(
      `${this.baseUrl}/detalle/por-asesor/${asesorId}`,
    );
  }
  
}
